import { useTenantConfig } from '../../../../../tenant-config/useTenantConfig';
import { MODERATION_MODELS_CONFIG } from '../../../../../tenant-config/tenantConfigConstants';
import { useMemo } from 'react';
import { TagData } from './moderationTagsTypes';
import { TAGS } from './moderationTags';

const OW_MODEL_PREFIX = 'ow_';

export function useTags() {
  const [modelsConfig] = useTenantConfig(MODERATION_MODELS_CONFIG);

  return useMemo(() => {
    if (!modelsConfig) return TAGS;

    const owTags: Array<TagData> = Object.entries(modelsConfig).reduce<Array<TagData>>(
      (acc, [key, value]) => {
        if (key.startsWith(OW_MODEL_PREFIX)) {
          acc.push({ value: key, text: value.name });
        }
        return acc;
      },
      []
    );

    return [...TAGS, ...owTags];
  }, [modelsConfig]);
}
